import { Flex, Stack, VStack, Text, Box } from "@chakra-ui/react";
import React from "react";
import { Gallery } from "react-grid-gallery";

const Cake = () => {
  return (
    <div>
      {Hero()}
      <Box my={10}>
      <Gallery images={images} />
      </Box>
    </div>
  );
};

const Hero = () => {
  return (
    <Flex
      w={"full"}
      h={"50vh"}
      backgroundImage={require("../imgs/birthdaycake.jpg")}
      backgroundSize={"cover"}
      backgroundPosition={"center center"}
    >
      <VStack
        w={"full"}
        justify={"center"}
        px={{ base: 4, md: 8 }}
        bgGradient={"linear(to-r, blackAlpha.600, transparent)"}
      >
        <Stack maxW={"2xl"} align={"flex-start"} spacing={6}>
          <Text
            color={"white"}
            fontWeight={700}
            lineHeight={1.2}
            fontSize={{ base: "3xl", md: "4xl" }}
            textAlign="center"
          >
            Birthday Cake
          </Text>
          <Text
            color={"white"}
            fontWeight={300}
            lineHeight={1.2}
            fontSize={{ base: "md", md: "2md" }}
          >
            With Miss.Y Cake, you can make every occasion in your life special!
          </Text>
        </Stack>
      </VStack>
    </Flex>
  );
};

const images = [
  {
    src: require("../imgs/showcase/1.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/2.jpg"),
    width: 500,
    height: 500,
  },

  {
    src: require("../imgs/showcase/3.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/4.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/5.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/6.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/7.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/8.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/9.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/10.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/11.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/12.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/13.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/14.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/15.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/16.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/17.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/18.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/19.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/20.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/21.jpg"),
    width: 500,
    height: 500,
  },
  
  {
    src: require("../imgs/showcase/22.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/24.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/25.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/26.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/27.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/31.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/32.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/33.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/36.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/51.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/52.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/53.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/54.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/56.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/57.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/58.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/59.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/63.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/64.jpg"),
    width: 500,
    height: 500,
  },
];

export default Cake;
